import {computed} from 'vue';
import type {PropType} from "vue";

export type IconPropType = string | string[] | Record<string, boolean>;

export const iconProp = {
  icon: {
    type: [String, Array, Object] as PropType<IconPropType>,
    required: false,
    default: '',
  },
};

export function useIconProp(props: { icon: IconPropType }) {
  // Computed property to determine the actual icon based on the icon prop
  const computedIcon = computed(() => {
    return getIconMethod(props.icon);
  });

  const getIconMethod = (icon: IconPropType): [string, string] | null => {
    const defaultPack = 'far'; // Default icon pack

    if (typeof icon === 'string' && icon) {
      return [defaultPack, icon];
    }

    if (Array.isArray(icon)) {
      const [iconPack, iconName] = icon;
      if (!iconName) return null;

      return [iconPack || defaultPack, iconName];
    }

    if (typeof icon === 'object' && icon !== null) {
      for (const [key, value] of Object.entries(icon)) {
        if (value) {
          return [defaultPack, key];
        }
      }
    }

    return null
  };

  return {
    computedIcon,
    getIconMethod,
  };
}